import { PageFilterType } from '@/types/locationDetailsPages/shared';

export const getFilterStringFromUid = (uid: PageFilterType): string => {
  return {
    backpacking: 'Backpacking trail reviews for',
    'bike-touring': 'Bike touring trail reviews for',
    birding: 'Birding trail reviews for',
    camping: 'Camping trail reviews for',
    'cross-country-skiing': 'Cross-country skiing trail reviews for',
    fishing: 'Fishing trail reviews for',
    'horseback-riding': 'Horseback riding trail reviews for',
    'mountain-biking': 'Mountain biking trail reviews for',
    'off-road-driving': 'Off-road driving trail reviews for',
    'paddle-sports': 'Paddle sports trail reviews for',
    'road-biking': 'Road biking trail reviews for',
    'rock-climbing': 'Rock climbing trail reviews for',
    'scenic-driving': 'Scenic driving trail reviews for',
    skiing: 'Skiing trail reviews for',
    snowshoeing: 'Snowshoeing trail reviews for',
    'trail-running': 'Running trail reviews for',
    'via-ferrata': 'Via ferrata trail reviews for',
    walking: 'Walking trail reviews for',
    ada: 'Wheelchair-friendly trail reviews for',
    beach: 'Beach trail reviews for',
    cave: 'Cave trail reviews for',
    'city-walk': 'City walk reviews for',
    'no-dogs': 'No dogs allowed trail reviews for',
    dogs: 'Dog friendly trail reviews for',
    'dogs-leash': 'Dogs on leash trail reviews for',
    forest: 'Forest trail reviews for',
    'historic-site': 'Historic site trail reviews for',
    'hot-springs': 'Hot springs trail reviews for',
    kids: 'Kid friendly trail reviews for',
    lake: 'Lake trail reviews for',
    'partially-paved': 'Partially paved trail reviews for',
    paved: 'Paved trail reviews for',
    'rails-trails': 'Rail trail reviews for',
    river: 'River trail reviews for',
    strollers: 'Stroller-friendly trail reviews for',
    views: 'Scenic viewpoint trail reviews for',
    waterfall: 'Waterfall trail reviews for',
    'wild-flowers': 'Wildflower trail reviews for',
    wildlife: 'Wildlife trail reviews for',
    easy: 'Easy trail reviews for',
    moderate: 'Moderate trail reviews for',
    hard: 'Hard trail reviews for',
    short: 'Short trail reviews for',
    long: 'Long trail reviews for'
  }[uid];
};
